import { Injectable } from '@angular/core'
import { TositeLaji } from '@lemon/core-firebase/model/tosite'

export type TositeHakuAikavali = 'viimeiset12kk' | 'viimeiset3kk' | 'viimeiset30pv' | 'tamaVuosi' | 'mukautettu' | 'kaikki'

export interface TositeHakuTila {
  hakuteksti: string
  aikavali: TositeHakuAikavali
  alkuPvm: number | null
  loppuPvm: number | null
  valitutMaksutavat: number[]
  valitutToimittajat: string[]
  valitutProjektit: string[]
  tositelaji: TositeLaji
  sivu: number
  sivunKoko: number
  paluureitti: string
}

@Injectable()
export class TositeHakuStateService {
  private _tila: TositeHakuTila | null = null
  private _tultuHakusivulta = false
  private _tultuUusiListauksesta = false

  asetaHakutila(tila: TositeHakuTila | null) {
    this._tila = tila
  }

  annaHakutila(): TositeHakuTila | null {
    return this._tila
  }

  tyhjennaHakutila() {
    this._tila = null
  }

  merkitseHakusivultaTulo() {
    this._tultuHakusivulta = true
  }

  merkitseUusiListauksestaTulo() {
    this._tultuUusiListauksesta = true
  }

  onkoTallennettuHaku(osoite: string): boolean {
    return this._tila?.paluureitti === osoite
  }

  onkoTultuHakusivulta(): boolean {
    return this._tultuHakusivulta && this._tila !== null
  }

  annaPaluureittiHausta(): string | null {
    if (!this._tultuHakusivulta || !this._tila) {
      return null
    }
    this._tultuHakusivulta = false
    return this._tila.paluureitti
  }

  onTultuListauksesta(): boolean {
    const arvo = this._tultuUusiListauksesta
    this._tultuUusiListauksesta = false
    return arvo
  }
}
